import mutations from './filters.mutations';
import actions from './filters.actions';
import getters from './filters.getters';
import state from './filters.state';

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/filters/index.js